import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MainInfo from 'components/brandSetting/MainInfo';
import {
  getBrand, getMarkets, getTemplates, resetTemplates, resetBrand, changeBrandCallEndedStatus,
} from 'actions/brand/brandActionCreator';
import { resetBrandSettings } from 'actions/brandSetting/brandSettingActionCreator';
import {
  selectBrand,
  selectBrandCallEndedStatus,
  selectBrandMainSetting,
  selectBrandMarkets,
  selectBrandTemplates,
} from 'selectors';

const mapStateToProps = ({
  brands, brandSetting,
}) => ({
  brand: selectBrand(brands),
  main: selectBrandMainSetting(brandSetting),
  markets: selectBrandMarkets(brands),
  templates: selectBrandTemplates(brands),
  callEndedStatus: selectBrandCallEndedStatus(brands),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    getBrand,
    getMarkets,
    getTemplates,
    resetTemplates,
    resetBrand,
    resetBrandSettings,
    changeBrandCallEndedStatus,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(MainInfo);
